import { render, staticRenderFns } from "./NewTasks.vue?vue&type=template&id=7584cdab&scoped=true"
import script from "./NewTasks.vue?vue&type=script&lang=js"
export * from "./NewTasks.vue?vue&type=script&lang=js"
import style0 from "./NewTasks.vue?vue&type=style&index=0&id=7584cdab&prod&lang=less&scoped=true"
import style1 from "./NewTasks.vue?vue&type=style&index=1&id=7584cdab&prod&lang=less&scoped=true"
import style2 from "./NewTasks.vue?vue&type=style&index=2&id=7584cdab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7584cdab",
  null
  
)

export default component.exports